import React from 'react';
//  components
import Header from '../components/public/Header';
import PayPal from '../components/public/PayPal';
// React Bootstrap
import { Container } from 'react-bootstrap';

function TestPage() {
  const [checkout, setCheckout] = React.useState(false);
  return (
    <>
      <Header />
      <Container>
        <h1>I am test page</h1>
        {
          checkout ? (
            <PayPal total={1} />
          ) : (
              <button onClick={() => setCheckout(true)}>
                checkout
              </button>
            )
        }


      </Container>
    </>
  );
}

export default TestPage;
